import React from "react";
import estilo from "./styles/CargaCapitulo.module.css";
import blanco from "../../img/blanco.png";

function CargaCapitulo() {
  return (
    <div className={estilo.carga}>
      <div className={estilo.informacion}>
        <div className={estilo.portada}>
          <img src={blanco} alt="portada-de-carga" />
        </div>

        <div className={estilo.datos}>
          <div className={estilo.nombre}>
            <div className={estilo.foto}></div>
            <div></div>
            <div></div>
          </div>
          <div className={estilo.sinopsis}>
            <div></div>
          </div>
        </div>
      </div>

      <div className={estilo.servidores}></div>

      <div className={estilo.botones}>
        <div></div>
        <div className={estilo.menu}></div>
        <div></div>
      </div>

      <div className={estilo.comentarios}></div>
    </div>
  );
}

export default CargaCapitulo;
